import { Footer } from '../Footer/Footer.tsx';
import { Menu } from '../Menu/Menu.tsx';
import { StateSelectionModal } from '../StateSelectionModal/StateSelectionModal.tsx';
import { FloatingActionBar } from '../FloatingActionBar/FloatingActionBar.tsx';
import { HubFab } from '../Hub/HubFab.tsx';
import { ZigBotFab } from '../ZigBot/ZigBotFab.tsx';
import { Outlet, useNavigate } from 'react-router';
import { useLayout } from '@/contexts/LayoutContext/useLayout';
import { BackButton } from './BackButton.tsx';
import { useCallback } from 'react';
import { AiChatPanel } from '../AiChat/AiChatPanel.tsx';
import { AiChatPanelProvider } from '@/contexts/AiChatPanelContext/AiChatPanelContext.tsx';
import { useAIPageContext } from '@/machines/useAIPageContext.ts';
import { useAIUserContext } from '@/machines/useAIUserContext.ts';
import { useSkillInferenceToasts } from '@/hooks/useSkillInferenceToasts.ts';
import { useEarnedBadgeToasts } from '@/hooks/useEarnedBadgeToasts.tsx';
import { cn } from '@/lib/utils';

export const Layout = () => {
    const { showFooter, backButton, mainContentBackgroundClass } = useLayout();
    const navigate = useNavigate();

    useAIPageContext();
    useAIUserContext();
    // A document upload keeps running after the user leaves the upload sheet so its outcome toast
    // has to be owned by the layout rather than any one page.
    useSkillInferenceToasts();
    useEarnedBadgeToasts();

    const onBack = useCallback(() => {
        if (backButton?.onBack) {
            backButton.onBack();
        }
        else {
            navigate(-1);
        }
    }, [backButton, navigate]);

    return (
        <AiChatPanelProvider>
            <div className="flex flex-col min-h-screen">
                <Menu />
                <main className={cn('relative z-10 flex flex-1 flex-col', mainContentBackgroundClass)}>
                    {backButton && (
                        // Transparent so `PageZigzagBackground` can run up behind it. `z-[1]` keeps the strip above the page subtree.
                        // `SidebarLayout`'s pinned mobile subheader stays clear because of its `top` and pin threshold share `MENU_BAR_HEIGHT_PX`.
                        <div className="relative z-[1]">
                            <BackButton
                                text={backButton.text}
                                variant={backButton.variant}
                                confirmTitle={backButton.confirmTitle}
                                confirmSubtitle={backButton.confirmSubtitle}
                                confirmMessage={backButton.confirmMessage}
                                confirmButtonText={backButton.confirmButtonText}
                                cancelButtonText={backButton.cancelButtonText}
                                tracking={backButton.tracking}
                                onBack={onBack}
                            />
                        </div>
                    )}
                    <Outlet />
                </main>
                {showFooter && <Footer />}
                <StateSelectionModal />
                <FloatingActionBar>
                    <HubFab />
                    <ZigBotFab />
                </FloatingActionBar>
                <AiChatPanel />
            </div>
        </AiChatPanelProvider>
    );
};
